import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[grid-card-header-tmp]' })
export class GridCardHeaderTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}
